<p-dialog [(visible)]="dialogOpen" [style]="{width: '450px'}" [header]="dialogTitle" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="form">
            <div class="p-field">
                <label for="name">Subject</label>
                <input type="text" pInputText id="name" formControlName="categoryName" required autofocus />
                <div *ngIf="form.controls['categoryName'].invalid && (form.controls['categoryName'].dirty ||form.controls['categoryName'].touched)" class="alert-danger">
                    <p *ngIf="form.controls['categoryName'].errors.invalidcategory">A subject with the name already exists</p>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
            <button type="button" [disabled]="form.invalid" pButton icon="fa-fw fa fa-check" (click)="save()" label="Save"></button>
            <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
        </div>
    </ng-template>
</p-dialog>